module.exports = __webpack_public_path__ + "img/model_face.0c97f6b8.png";